export type NetworkErrorEvent = {
  message: string;
  detail: string;
  at: number;
};

type Listener = (event: NetworkErrorEvent) => void;

const listeners = new Set<Listener>();
let lastEmitAt = 0;

/** Coalesce bursts (e.g. a page with many file requests) into one surfaced error. */
const MIN_EMIT_INTERVAL_MS = 4000;

export function reportNetworkError(input: { message: string; detail?: string }): void {
  const now = Date.now();
  if (now - lastEmitAt < MIN_EMIT_INTERVAL_MS) {
    return;
  }
  lastEmitAt = now;
  const event: NetworkErrorEvent = {
    message: input.message,
    detail: input.detail ?? '',
    at: now,
  };
  for (const listener of listeners) {
    listener(event);
  }
}

export function subscribeNetworkError(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
